import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  unitGrams: {
    description: 'Label indicating the "grams" weight unit of measurement',
    defaultMessage: 'g',
    id: 'K0SKoR',
  },
  unitGramsWithParentheses: {
    description: 'unit of measure grams',
    defaultMessage: '(g)',
    id: 'aKsZ+N',
  },
  unitKilograms: {
    description: 'Label indicating the "kilograms" weight unit of measurement',
    defaultMessage: 'kg',
    id: '2bS4EK',
  },
  unitKilogramsWithParentheses: {
    description: 'unit of measure kilograms',
    defaultMessage: '(kg)',
    id: 'lR632P',
  },
  unitOunces: {
    description: 'Label indicating the "ounces" weight unit of measurement',
    defaultMessage: 'oz',
    id: 'Ab239Q',
  },
  unitOuncesWithParentheses: {
    description: 'unit of measure ounces',
    defaultMessage: '(oz)',
    id: 'hWhQ7C',
  },
  unitPounds: {
    description: 'Label indicating the "pounds" weight unit of measurement',
    defaultMessage: 'lbs',
    id: 'QaRb2i',
  },
  unitPoundsWithParentheses: {
    description: 'unit of measure pounds',
    defaultMessage: '(lb)',
    id: 'VHkL6w',
  },
});
